import { DialogHeaderBordered } from './dialog-header-bordered'
import { DialogHeaderFunctional } from './dialog-header-functional'

export const DialogHeader = Object.assign(DialogHeaderBordered, {
  Functional: DialogHeaderFunctional,
})
